(() => {
  'use strict';
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = () => {
    for (const track of document.querySelectorAll('.announce__track')) {
      for (const extra of track.querySelectorAll('[data-announce-extra]')) extra.remove();
      const first = track.querySelector('.announce__item');
      if (!first) continue;
      // Liquid supplies two equal sequences. Repeat that pair only when a
      // desktop viewport is wider than one sequence, keeping the -50% loop exact.
      const desktop = innerWidth >= 1081;
      const paused = document.documentElement.dataset.polygonsMotionPaused === 'true';
      if (desktop && !reducedMotion.matches && !paused) {
        const sequenceWidth = track.scrollWidth / 2;
        const viewportWidth = track.parentElement?.clientWidth || innerWidth;
        const pairs = sequenceWidth > 0 ? Math.min(16, Math.ceil(viewportWidth / sequenceWidth)) : 1;
        const originalPair = [...track.children];
        for (let pair = 1; pair < pairs; pair += 1) {
          for (const item of originalPair) {
            const clone = item.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('data-announce-extra', '');
            track.append(clone);
          }
        }
      }
      const speed = 42;
      const start = Math.max(0, innerWidth * .75 - parseFloat(getComputedStyle(first).paddingLeft));
      track.style.setProperty('--announce-start', `${start}px`);
      track.style.setProperty('--announce-intro-duration', `${start / speed}s`);
      track.style.setProperty('--announce-loop-duration', `${track.scrollWidth / 2 / speed}s`);
      track.dataset.motionReady = 'true';
    }
  };
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; initialize(); });
  };
  if (document.fonts?.ready) document.fonts.ready.then(initialize);
  else initialize();
  document.fonts?.addEventListener?.('loadingdone', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  reducedMotion.addEventListener('change', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { attributes: true, attributeFilter: ['data-polygons-motion-paused'] });
  document.addEventListener('shopify:section:load', initialize);
})();
